
import * as Models from '../commonModels';
import * as CarModels from '../car/car';
import * as GarageModels from '../garage/garage';
import * as CustomerModels from '../customer/customer';
import { GaragePreviewModel } from '../garage/garage';
import * as SpecificationModels from '../specification/specification';
import * as KsefModels from '../ksef/ksef';

export class GarageInvoiceObjectModel extends Models.ResponseBase {
  Item: GarageInvoiceModel;
}

export class GarageInvoiceListModel extends Models.ListBaseModelWithAdditonalReturnInformation {
    Items: GarageInvoiceModel[];
  }

export class GarageInvoiceModel {
  public GarageInvoiceId: number;
  public BaseGarageInvoiceId: number;
  public GarageId: number;
  public Number: string;
  public IssueDate: Date;
  public SaleDate: Date;
  public KSeFDate: Date;
  public NetValue: number;
  public IsSentRequestForCorrection: boolean;
  public AddedByUserId: number;
  public AddDate: Date;
  public OnePercent: boolean ;

  public Garage: GaragePreviewModel ;
  public SpecificationValue: number;
  public TyreCount: number;
  public Difference: number;
  public AddedByUser: string;
  public DeletedByUser: string;
  public DeleteDate: Date;
  public GarageInvoicePreview: GarageInvoicePreviewModel;
  public Corrections: GarageInvoiceCorrectionModel[];
  public SpecificationIds: number[];
  public Specifications: string[];
  public Note: string;
  public RegistrationNumber: string;
  public IterationNumber: number;

  public CorrectionRequests: GarageInvoiceCorrectionRequest[];

  public ExecuteVerified: boolean;

  public UpdatedByUserId: number;
  public UpdateDate: Date;
  public UpdatedByUser: string;

  public VerifiedByUserId: number;
  public VerifiedDate: Date;
  public VerifiedByUser: string;


  public IsVerified: boolean;

  public SpecificationList: SpecificationModels.SpecificationModel[];

  public IsCurrentDateRegistration: boolean;

  public IsTransferContractorInvoice: boolean;

  public KSeFInvoiceCost: KsefModels.KSeFInvoiceCostModel;

  public ServiceCompanyName: string;

  public ServiceCompanyNip: string;

  public AmountPayable?: number;

  public IsSystemCorrectionSettled?: boolean;

  public SystemCorrectionNote?: string;



  constructor(garageId?: number) {
    this.Number = null;
    this. NetValue = null;
    this. OnePercent = false;
    this. IssueDate = null;
    this.GarageId = garageId || null;
  }
}


export class GarageInvoiceCorrectionRequest {
  public GarageInvoiceId: number;
  public NetValue: number;
  public AddDate: Date;
  public AddedByUser: string;
  public Note: string;
  public GarageId: number;
}

export class GarageInvoiceCorrectionModel {
  public GarageInvoiceId: number;
  public BaseGarageInvoiceId: number | null;
  public Number: string;
  public NetValue: number | null;
  public OnePercent: boolean | null;
  public AddedByUser: string;
  public IssueDate: Date;
  public AddDate: Date;
  public Note: string;
  public RegistrationNumber: string;
  constructor() {
    this.Note = null;
    this.NetValue = null;
    this.GarageInvoiceId = null;
  }
}

export class GarageInvoicePreviewModel {
    public GarageInvoiceId: number;
    public Number: string;
    public BadgeInfo1: BadgeInfo1;
    public BadgeInfo2: BadgeInfo2;
}


export  class BadgeInfo1 {
    public IsDeleted: boolean;
    public OnePercentInvoice: boolean;
    public BaseGarageInvoiceId: number;
    public Number: string;
    public IssueDate: Date;
    public NetValue: number;
    public AddDate: Date;
    public AddedByUser: string;
    public DeletedByUser: string;
    public DeleteDate: Date;
}

export class BadgeInfo2 {
    public IsSentRequestForCorrection: boolean;
}


export class LinkedSpecificationListModel extends Models.ListBaseModel {
  Items: LinkedSpecificationModel[];
  public GarageInvoiceId: number;
}

export class LinkedSpecificationModel {
  constructor() {
    this.Number = null;
    this.RegistrationNumber = null;
    this.AddDate = null;
  }

  public Number: string;
  public RegistrationNumber: string;
  public AddDate: Date;
  public SpecificationId: number;
}

export class PrintDataListModel extends Models.ListBaseModel {
  Items: PrintDataModel[];
  public GarageInvoiceId: number;
  public Garage: string;
  public AddedByUser: string;
  public VerifiedByUser: string;
  public Number: string;
  public RegistrationNumber: string;

  public GarageServiceValue: string; // * Wartość usług serwis
  public GarageArticleValue: string; // * Wartość towarów - serwis
  public GarageSumValue: string; // * Serwis suma

  public CustomerServiceValue: string;   // * Wartość usług - klient
  public CustomerArticleValue: string;  // * Wartość towarów - klient
  public CustomerSumValue: string;   // * Klient suma

  public AfterSaleValue: string; // * z pos.
  public Profit: string; // * zysk
  public ProfitNetNet: string; // * zysk net net

  public Summary: GarageInvoicePrintSummaryDataModel[];
}

export class PrintDataModel {
  public AddDate: string ;
  public Customer: string;
  public Number: string;
  public GarageServiceValue: string;
  public GarageArticleValue: string;
  public GarageSumValue: string;
  public CustomerServiceValue: string;
  public CustomerArticleValue: string;
  public CustomerSumValue: string;
  public AfterSaleValue: string;
  public Profit: string;
  public Garage: string;
  public CarRegistrationNumber: string;
  public IsGarageInvoice: string;
  public IsInvoice: string;
  public IsModified: string;
  public Mechanics: string;
  public TyreCount: string;

}

export class GarageInvoicePrintSummaryDataModel  {
  public Customer: string;
  public GarageSumValue: string;
  public CustomerSumValue: string;
  public TyreCount: string;
  public GarageServiceValue: string;
  public GarageArticleValue: string;
  public CustomerServiceValue: string;
  public CustomerArticleValue: string;
  public AfterSaleValue: string;
  public Profit: string;
}

export class GarageInvoiceSearchModel extends Models.SearchBaseModel {

  public GarageId: number;
  public GarageName: string;
  public Number: string;
  public RegistrationNumber: string;
  public Month: number;
  public DateRange: Models.DateRange;
  public IsSentRequestForCorrection: boolean;
  public IsCorrectionIssued: boolean;
  public IsInvoiceDeleted: boolean;
  public IsOnePercentDiscountInvoice: boolean;
  public GarageInvoiceId: number;
  public period: any;
  public IsCorrectionVisible: boolean;
  public IsKSeFInvoice: boolean;
  public IsSystemCorrectionSettled: boolean;
  public MonthVAT: number;

  constructor() {
    super();
    this.GarageInvoiceId = null;

    this.GarageId = null;
    this.GarageName = null;
    this.Number = null;
    this.RegistrationNumber = null;
    this.Month = null;
    this.DateRange = new Models.DateRange();
    this.period = null;
    this.IsSentRequestForCorrection = null;
    this.IsCorrectionIssued = null;
    this.IsInvoiceDeleted = null;
    this.IsOnePercentDiscountInvoice = null;
    this.IsCorrectionVisible = false;
  }

}
